/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { invalidateTenantPlanCache } from "../../admin_store/utils/subscriptionPlan";
import { markSubscriptionExpired } from "../../admin_store/utils/expiredPlanAccess";

export async function saveTenantPlan(plan, isArabic = true) {
    const baseUrl =
      process.env.NODE_ENV === "development"
        ? "/api"
        : (process.env.REACT_APP_API_BASE_URL || "https://madar-api.madar.iq/api").replace(/\/+$/, "");
  
    const tenantId = localStorage.getItem("tenantId");
    const token = localStorage.getItem("authToken") || localStorage.getItem("token");
  
    if (!tenantId) throw new Error("TenantId missing");

    const body = {
      tenantId: parseInt(tenantId),
      planId: plan.planId,
      planType: plan.title || plan.planType || "",
      engPlanType: plan.engTitle || plan.engPlanType || "",
      price: plan.price || 0,
      descripsion: plan.desc || plan.descripsion || "",
      engDescripsion: plan.engDescripsion || "",
      creationDate: new Date().toISOString(),
    };
  
    for (let i = 1; i <= 8; i++) {
      body[`note${i}`] = localStorage.getItem(`selectedPlanNote${i}`) || "";
      body[`engNote${i}`] = "";
    }
  
    const res = await fetch(
      `${baseUrl}/Plans/SaveTenantPlan?TenantId=${tenantId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
        body: JSON.stringify(body),
      }
    );
  
    if (!res.ok) {
      const txt = await res.text();
      throw new Error("SaveTenantPlan failed: " + txt);
    }

    invalidateTenantPlanCache();
    markSubscriptionExpired(false);
    try {
      const current = JSON.parse(localStorage.getItem("subscription") || "null");
      if (current && typeof current === "object") {
        localStorage.setItem(
          "subscription",
          JSON.stringify({ ...current, isExpired: false })
        );
      }
    } catch {
      /* ignore */
    }
  }
  